import React from 'react';

const SvgAttachment = props => (
  <svg width={12} height={11} {...props}>
    <path
      d="M11.092.916a3.08 3.08 0 0 0-4.384 0L.681 7.001a2.362 2.362 0 0 0 0 3.319 2.302 2.302 0 0 0 2.76.387.382.382 0 0 0 .254-.11l6.027-6.085a1.575 1.575 0 0 0 0-2.212 1.54 1.54 0 0 0-2.191 0L2.599 7.278a.394.394 0 0 0 0 .553.385.385 0 0 0 .548 0l4.932-4.978a.769.769 0 0 1 1.095 0 .787.787 0 0 1 0 1.106L3.42 9.767a1.54 1.54 0 0 1-2.191 0 1.575 1.575 0 0 1 0-2.212L7.256 1.47a2.31 2.31 0 0 1 3.288 0 2.362 2.362 0 0 1 0 3.32l-5.48 5.53a.394.394 0 0 0 0 .554.385.385 0 0 0 .549 0l5.48-5.532a3.15 3.15 0 0 0 0-4.425z"
      fill="#9A9EB0"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgAttachment;
